/**
 * True when the URL carries enough context to load a public (signed-out) company report.
 * Requires a non-empty website query param (domain).
 */
export function hasPublicReportWebsiteSearch(search) {
  const q = typeof search === 'string' ? search.replace(/^\?/, '') : '';
  const params = new URLSearchParams(q);
  const website = params.get('website');
  return Boolean(website && String(website).trim());
}

/**
 * Path to the company grants report (Summary + grants).
 * Formerly served at `/?website=…`; now at `/grants-section?website=…`.
 */
export function buildPublicReportPath({ website, company, search } = {}) {
  const params =
    search != null
      ? new URLSearchParams(typeof search === 'string' ? search.replace(/^\?/, '') : search)
      : new URLSearchParams();
  if (website) params.set('website', String(website));
  if (company) params.set('company', String(company));
  const q = params.toString();
  return q ? `/grants-section?${q}` : '/grants-section';
}
